import { useCallback } from 'react';

import {
  useDispatch,
  useSelector,
} from 'react-redux';

import {
  postAuthenticationCode,
  PostAuthenticationCodeParams,
} from '../../actions/auth/postAuthenticationCode';
import { resetRequest } from '../../actions/requests';

import { AUTHENTICATION_CODE_POST_REQUEST_KEY } from '../../constants';
import { ReduxState } from '../../reducers';
import { getPreferredMethod } from '../../reducers/auth';

import { getRequestStates } from '../../selectors';

export type UsePostAuthenticationCodeParams = PostAuthenticationCodeParams;
export const usePostAuthenticationCode = () => {
  const data = useSelector(state => ({
    preferredMethod: getPreferredMethod(state),
  }));

  const postAuthenticationCodeRequestState = (state: ReduxState) =>
    getRequestStates(state, AUTHENTICATION_CODE_POST_REQUEST_KEY);

  const {
    error,
    errorMessage,
    isFetching,
    isSuccess,
  } = useSelector(postAuthenticationCodeRequestState);

  const dispatch = useDispatch();

  const execute = (requestData: UsePostAuthenticationCodeParams) => {
    dispatch(postAuthenticationCode(requestData));
  };

  const reset = () => {
    dispatch(resetRequest(AUTHENTICATION_CODE_POST_REQUEST_KEY));
  };

  return {
    data,
    error,
    errorMessage,
    isLoading: isFetching,
    isSuccess,
    execute: useCallback(execute, [dispatch]),
    reset: useCallback(reset, [dispatch])
  };
};
